/**
 * 登录功能
 * safari-浏览器-跳转到auth页面登录（因为xbase/sdk不兼容该浏览器）
 * 其他浏览器-跳转到/login
 */
import { SSO } from '@xbase/sso'
import { SSOconfig as xbaseConfig, PACKAGE_NAME } from '@remote/api/config'
import genDeviceUtil from '@/utils/genDeviceUtil'
import { logFactory } from '@remote/utils/logger'

const log = logFactory('LoginIfream:')
let isInitView = false

export default function (signInByIFrameParams = {}, route, callback = null) {
  log('1 - route', route && route.name)
  const signInByIFrameConfig = {
    ...xbaseConfig,
    // 空白页面-避免页面内网嵌套
    // signInRedirectURI: 'https://pan.xunlei.com/blank/',
    ...signInByIFrameParams,
  }

  const ssoByIFrame = new SSO(signInByIFrameConfig)

  const initView = async () => {
    try {
      const deviceUtil = await genDeviceUtil
      const deviceId = await deviceUtil.deviceID
      const deviceSign = await deviceUtil.deviceSign
      ssoByIFrame._oAuth2Client._config.statInfo.deviceId = deviceId
      ssoByIFrame._oAuth2Client._config.statInfo.deviceSign = deviceSign
      const isLogined = await ssoByIFrame.init()
      log('2 - isLogined', isLogined)
      if (isLogined) {
        // 已登陆,如果是登录页面，跳转到首页
        // if (route && route.name === 'login') {
        //   window.location.replace(`https://${PACKAGE_NAME}/yc` + location.search)
        // } else {
        //   window.location.reload()
        // }
        window.location.replace(`https://${PACKAGE_NAME}/yc/home` + location.search)
      } else {
        // 内嵌需要调用signInByIFrame 为了兼容safari浏览器（xbase/sdk不支持safari），需要跳转页面完成登录
        // const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent)
        // 线上环境可以正常登陆和退出,因此先打开iframe登陆模式
        const isSafari = false
        if (isSafari) {
          await ssoByIFrame.signIn()
        } else {
          log('3 - 1 reload')
          await ssoByIFrame.signInByIFrame({
            showType: 'embed',
            container: document.getElementById('login-wrap'),
            // browserWindow: {}
          })
          log('3 - 2 reload')
          if (callback) callback()
          else window.location.reload()
        }
      }
    } catch (error) {
      if (error && error.error === 'unauthenticated') {
        // 初始化时，报错unauthenticated为token失效，跳转登录页
        window.location.reload()
        log('4 - error', error)
      }
      log('5 - error', error)
    }
  }
  if (!isInitView) initView()
  isInitView = true
}
